import { graphql } from "gatsby";
import React from "react";
import CaretakersContent from "../components/organisms/caretakers-content/caretakers-content";
import CaretakersLayout from "../components/organisms/caretakers-layout/caretakers-layout";
import SEO from "../shared/components/atoms/seo/seo";
// import Layout from "../shared/components/organisms/layout/layout";
import '../shared/styles/index.scss';
import { siteUrl } from '../shared/utils/siteUrl';

// import SEO from "../shared/components/atoms/seo/seo"

class IndexPage extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {
    const pageData = this.props.data.allContentfulPequeninCursoCuidadores.nodes[0].referenciaPremioVirtual[0].paginasInternas.filter(e => e.slug === "curso-de-cuidadores/")[0]
    return (
      <CaretakersLayout activeMenu={0}>
        <SEO
          title={pageData.metaTitulo}
          description={pageData.metaDescripcion.metaDescripcion}
          url={siteUrl + '/' + pageData.slug}
          image={pageData.metaImagen && pageData.metaImagen.file.url}
        />
        <CaretakersContent contentInfo={pageData} />
      </CaretakersLayout>
    )
  }
}

export const query = graphql`

    query GET_CARETAKERS_MAIN_CONTENT($locale: String){
      allContentfulPequeninCursoCuidadores(filter: {node_locale: {eq: $locale}}) {
        nodes {
          referenciaPremioVirtual {
            paginasInternas {
              metaTitulo
              metaImagen {
                file {
                  url
                }
              }
              metaDescripcion {
                metaDescripcion
              }
              slug
              referenciaContenidoCursoCuidadores {
                tituloGeneral
                descripcion {
                  raw
                }
                textoBoton
                redireccionBoton
                imagen {
                  description
                  file {
                    url
                  }
                }
                index
                listaContenidos {
                  tituloGeneral
                  descripcion {
                    raw
                  }
                  textoBoton
                  redireccionBoton
                  imagen {
                    description
                    file {
                      url
                    }
                  }
                  index
                }
              }
            }
          }
        }
      }
      
    }
`

export default IndexPage
